var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"no-body":""}},[_c('DraftsList',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.items),expression:"!items"}],attrs:{"module":_vm.module,"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }